import styled from "@emotion/styled";
import {ButtonHTMLAttributes, ReactNode} from "react";

const ButtonBox = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 0 16px;
    margin-top: auto; // TODO margin-top: 16px
    margin-bottom: 25px;
    background: linear-gradient(
            180deg,
            rgba(255, 255, 255, 0.00) 0%,
            rgba(255, 255, 255, 0.80) 11.98%,
            #FFF 102.45%
    );
`;

const NextButton = styled.button`
    width: 100%;
    border-radius: 14px;
    border: none;
    background-color: ${({theme}) => theme.background[3]};
    height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;

    color: white;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;

    &:disabled {
        background-color: ${({theme}) => theme.color[3]};
        border: none;
        color: #fff;
        cursor: auto;
    }
`;
const PrevButton = styled.button`
    width: 128px;
    border-radius: 14px;
    border: none;
    background-color: ${({theme}) => theme.background[4]};
    height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
`;

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
    children?: ReactNode
    prev?: () => void;
    confirm?: () => void;
}

export default function Button({children, prev, confirm, ...props}: Props) {
    return (
        <ButtonBox>
            {prev && <PrevButton onClick={prev}>이전</PrevButton>}
            <NextButton onClick={confirm} {...props}>{children}</NextButton>
        </ButtonBox>
    );
}
